export const OTP_DIGITS_NUMBER = 6;
